import { useSnackbar } from 'notistack';

export const useNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const openNotification = data => {
    const autoHideDuration = ['error', 'info', 'warning'].includes(data.type)
      ? undefined
      : 6000;

    return enqueueSnackbar({
      closeSnackbar,
      autoHideDuration,
      persist: !autoHideDuration,
      variant: data.type,
      ...data,
    });
  };

  const openSuccessNotification = data =>
    openNotification({
      type: 'success',
      title: 'Sucesso!',
      ...data,
    });

  const openErrorNotification = data =>
    openNotification({
      type: 'error',
      title: 'Ocorreu um erro, tente mais tarde',
      ...data,
    });

  return {
    setNotify: openNotification, // Remove after change all setNotify for openNotification
    openNotification,
    closeAllNotifications: () => closeSnackbar(),
    openErrorNotification,
    openSuccessNotification,
  };
};
